export const changeToDecimalString = (change: number | undefined) =>
  change
    ? `${change > 0 ? '+' : '-'}${Math.abs(change).toFixed(2)}`
    : undefined;
